import { thirdPartyOwnerHeading } from './thirdPartyOwnerHeading';

export const thirdPartyOwnerHeadingForOrders = {
    ...thirdPartyOwnerHeading,
    colId: 'orderThirdPartyOwner',
};
